import { ProfileType } from "~/graphql/supergraphTypes";
import { ExtractedDataField } from "./ProfileConflictResolver/profileDataComparison";

const normalizeName = (name?: string | null) => {
  if (!name) return undefined;
  return name.trim().toLowerCase();
};

export const getMatchingProfile = (
  profiles: Array<ProfileType>,
  extractedData?: ExtractedDataField | null,
): ProfileType | undefined => {
  if (!profiles || !extractedData) return undefined;

  const matchingProfile = profiles.find((profile) => {
    const firstName = normalizeName(profile.firstName);
    const lastName = normalizeName(profile.lastName);
    const middleName = normalizeName(profile.middleName);
    const extractedFirstName = normalizeName(extractedData.first_name);
    const extractedLastName = normalizeName(extractedData.last_name);
    const extractedMiddleName = normalizeName(extractedData.middle_name);

    const legalName = normalizeName(profile.legalName);
    const extractedLegalName = normalizeName(extractedData.legal_name);

    const firstNameMatch = firstName && extractedFirstName && firstName === extractedFirstName;
    const lastNameMatch = lastName && extractedLastName && lastName === extractedLastName;
    const middleNameMatch =
      middleName && extractedMiddleName && middleName === extractedMiddleName;
    const lastNameAsMiddleMatch =
      lastName && extractedMiddleName && lastName === extractedMiddleName;
    const middleNameAsLastMatch =
      middleName && extractedLastName && middleName === extractedLastName;
    const legalNameMatch = legalName && extractedLegalName && legalName === extractedLegalName;

    return (
      (firstNameMatch &&
        (lastNameMatch || middleNameMatch || lastNameAsMiddleMatch || middleNameAsLastMatch)) ||
      legalNameMatch
    );
  });

  return matchingProfile;
};
